import axios from "axios";

// API base URL resolution.
//
// Production / preview: the page and the backend are served behind the same
// ingress, so `/api/*` always reaches the FastAPI backend on the same origin.
// Using a relative `/api` path makes login immune to a wrong
// REACT_APP_BACKEND_URL baked into the bundle.
//
// Local CRA dev (yarn start on http://localhost:3000 with backend on :8001):
// the dev server runs cross-origin to the backend, so we fall back to the env
// var (or to http://localhost:8001 as a last resort).
function resolveApiBase() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const isLocalDev =
      host === "localhost" || host === "127.0.0.1" || host.endsWith(".local");
    if (!isLocalDev) {
      // Production, preview, custom-domain, emergent.host — always same-origin.
      return "/api";
    }
  }
  const env = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  return env ? `${env}/api` : "http://localhost:8001/api";
}
export const API = resolveApiBase();

export const api = axios.create({
  baseURL: API,
});

// attach access token from localStorage as fallback (works alongside cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Better message for the common failure modes (network down, wrong backend URL,
// CORS, …) so users / support see something actionable instead of a generic
// "Something went wrong".
export function describeAxiosError(e) {
  if (!e) return "Unknown error.";
  if (e.response) {
    // The server responded with an HTTP status.
    const status = e.response.status;
    const detail = formatApiErrorDetail(e.response.data && e.response.data.detail);
    if (detail && detail !== "Something went wrong. Please try again.") return detail;
    if (status === 404) return `Backend endpoint not found (HTTP 404). The frontend may be pointing to the wrong domain.`;
    if (status === 401) return "Invalid credentials.";
    if (status === 403) return "Not allowed.";
    if (status === 429) return "Too many attempts — please wait a few minutes and try again.";
    return `Server returned HTTP ${status}.`;
  }
  if (e.request) {
    // No response received — typically network or CORS.
    return "Cannot reach the server. Check your internet connection.";
  }
  return e.message || "Request failed.";
}
